<template>
  <div class="">
    <p class="text-gray-800 text-sm md:text-base text-center"></p>
    <form @submit.prevent="handleRegister">
      <div class="mb-6">
        <label for="email" class="block text-gray-700 text-sm font-medium mb-2">
          E-mail
        </label>
        <input
          v-model="email"
          type="email"
          id="email"
          class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
          placeholder="E-mail do Administrador"
          required
          aria-label="E-mail"
        />
      </div>

      <div class="mb-6">
        <label
          for="username"
          class="block text-gray-700 text-sm font-medium mb-2"
          >Nome do Administrador</label
        >
        <input
          v-model="username"
          type="text"
          id="username"
          class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
          placeholder="Nome do Administrador"
          required
          aria-label="Nome de usuário"
        />
      </div>

      <div class="mb-6">
        <label
          for="password"
          class="block text-gray-700 text-sm font-medium mb-2"
          >Senha</label
        >
        <input
          v-model="password"
          :type="showPassword ? 'text' : 'password'"
          id="password"
          class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
          placeholder="Senha do Administrador"
          required
          aria-label="Senha"
          autocomplete="current-password"
        />
        <button
          type="button"
          class="absolute right-3 top-1/2 transform -translate-y-1/2 hover:text-gray-900"
          @click="togglePassword"
        >
          <svg
            v-if="!showPassword"
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 5C7.5 5 3.73 7.61 2 12c1.73 4.39 5.5 7 10 7s8.27-2.61 10-7c-1.73-4.39-5.5-7-10-7zm0 12c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
              fill="currentColor"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 6.5c2.6 0 5.02 1.28 6.5 3.5-1.48 2.22-3.9 3.5-6.5 3.5s-5.02-1.28-6.5-3.5c1.48-2.22 3.9-3.5 6.5-3.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>

      <div class="mb-4">
        <label
          for="confirmPassword"
          class="block text-gray-700 text-sm font-medium mb-2"
          >Confirmar Senha</label
        >
        <input
          v-model="confirmPassword"
          type="password"
          id="confirmPassword"
          class="w-full p-4 bg-gray-200 rounded-lg focus:ring-2 focus:ring-blue-400"
          placeholder="Confirme a senha"
          required
          aria-label="Confirmar Senha"
          autocomplete="current-password"
        />
      </div>

      <button
        type="submit"
        class="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 rounded-lg transition flex items-center justify-center gap-2"
        :disabled="loading"
      >
        <svg
          v-if="loading"
          class="animate-spin h-5 w-5 text-white"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          ></circle>
          <path
            class="opacity-75"
            fill="currentColor"
            d="M12 2a10 10 0 0110 10h-4a6 6 0 00-6-6V2z"
          ></path>
        </svg>
        <span>{{ loading ? 'Registrando...' : 'Cadastrar' }}</span>
      </button>
    </form>

    <p v-if="errorMessage" class="text-red-500 text-xs mt-1">
      {{ errorMessage }}
    </p>
    <p v-if="successMessage" class="text-green-500 text-xs mt-1">
      {{ successMessage }}
    </p>
  </div>
</template>

<script>
import { register } from '@/services/auth/api.auth'

export default {
  name: 'RegisterForm',
  data() {
    return {
      email: '',
      username: '',
      password: '',
      confirmPassword: '',
      loading: false,
      errorMessage: '',
      successMessage: '',
      showPassword: false,
    }
  },
  methods: {
    async handleRegister() {
      this.loading = true
      this.errorMessage = ''
      this.successMessage = ''

      if (this.password !== this.confirmPassword) {
        this.errorMessage = 'As senhas não coincidem.'
        this.loading = false
        return
      }

      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailPattern.test(this.email)) {
        this.errorMessage = 'Por favor insira um e-mail válido.'
        this.loading = false
        return
      }

      try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const response = await register(
          this.email,
          this.username,
          this.password,
          this.enterpriseId || '',
          this.enterprise,
          (this.role = 'admin')
        )

        if (response && response) {
          this.successMessage = 'Registro bem-sucedido!'
          setTimeout(() => {
            this.$router.push('/admin/dashboard')
          }, 15)
        } else {
          this.errorMessage = response.message || 'Erro ao registrar.'
        }
      } catch (error) {
        if (error.response && error.response.data) {
          this.errorMessage =
            error.response.data.message || 'Erro ao registrar.'
        } else {
          this.errorMessage = error.message || 'Erro ao registrar.'
        }
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    togglePassword() {
      this.showPassword = !this.showPassword
    },
  },
}
</script>
